var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 12.0049C16.7911 12.0049 17.5645 12.2395 18.2223 12.679C18.8801 13.1185 19.3928 13.7432 19.6955 14.4741C19.9983 15.2051 20.0775 16.0093 19.9231 16.7852C19.7688 17.5612 19.3878 18.2739 18.8284 18.8333C18.269 19.3927 17.5563 19.7737 16.7804 19.928C16.0044 20.0824 15.2002 20.0032 14.4693 19.7004C13.7384 19.3977 13.1136 18.885 12.6741 18.2272C12.2346 17.5694 12 16.796 12 16.0049C12.0012 14.9444 12.423 13.9277 13.1729 13.1778C13.9228 12.4279 14.9395 12.0061 16 12.0049ZM16 10.0049C14.8133 10.0049 13.6533 10.3568 12.6666 11.0161C11.6799 11.6754 10.9109 12.6124 10.4567 13.7088C10.0026 14.8051 9.88378 16.0115 10.1153 17.1754C10.3468 18.3393 10.9182 19.4084 11.7574 20.2475C12.5965 21.0866 13.6656 21.6581 14.8295 21.8896C15.9933 22.1211 17.1997 22.0023 18.2961 21.5482C19.3925 21.094 20.3295 20.325 20.9888 19.3383C21.6481 18.3516 22 17.1916 22 16.0049C22 14.4136 21.3679 12.8875 20.2426 11.7622C19.1174 10.637 17.5913 10.0049 16 10.0049Z",
    fill: "#424242"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.80763 5.39843L5.39355 6.8125L8.89939 10.3183L10.3135 8.90426L6.80763 5.39843Z",
    fill: "#424242"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 15.0049H2V17.0049H7V15.0049Z",
    fill: "#424242"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.89939 21.6914L5.39355 25.1973L6.80763 26.6113L10.3135 23.1055L8.89939 21.6914Z",
    fill: "#424242"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17 25.0049H15V30.0049H17V25.0049Z",
    fill: "#424242"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1006 21.6915L21.6865 23.1055L25.1924 26.6114L26.6064 25.1973L23.1006 21.6915Z",
    fill: "#424242"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30 15.0049H25V17.0049H30V15.0049Z",
    fill: "#424242"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1924 5.39846L21.6865 8.9043L23.1006 10.3184L26.6064 6.81253L25.1924 5.39846Z",
    fill: "#424242"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17 2.00488H15V7.00488H17V2.00488Z",
    fill: "#424242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.44de0dfa2a0af4726db6ad3b309a91a9.svg";
export { ForwardRef as ReactComponent };